<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="wrap">
    <div class="board">
      <div class="key_visual addImg con">
        <div class="container">
          <p>콘텐츠</p>
        </div>
      </div>
      <div class="search_area">
        <div class="container">
          <div class="search_group">
            <ul class="type">
              <!-- <li class="types all"><a href="/contents">ALL</a></li> -->
              <li class="types all" :class="{ on: !searchType }">
                <a @click="changeCategory('')">ALL</a>
              </li>
              <!-- <a :to="'/contents'" @click="getData()">ALL</a></li> -->
              <!-- <router-link :to="'/contents'" @click="getData()">ALL</router-link></li> -->
              <div v-if="category">
                <div v-for="(item, index) in category" :key="index">
                  <!-- <li :class="'types ' + item.name "> -->
                  <li
                    class="types"
                    :class="{
                      healthcare: item.name === '헬스케어',
                      it: item.name === 'IT',
                      on: item.name === searchType,
                    }"
                  >
                    <!-- <li class="types" :class="[{healthcare: item.name === '헬스케어' }, {it: ite.name === 'IT' }, { on: item.name === searchType }]"> -->
                    <!-- <a :to="'/contents?search_type=' + item.name" @click="getData(0, item.name, null )"> -->
                    <!-- <a :to="'/contents?search_type=' + item.name" @click="changeCategory(item.name)"> -->
                    <a @click="changeCategory(item.name)">
                      {{ item.name }}
                    </a>
                    <!-- <router-link :to="'/contents?search_type=' + item.name" @click="getData(0, item.name, null )">
                      {{item.name}}
                    </router-link> -->
                  </li>
                </div>
              </div>
            </ul>

            <div class="search_form">
              <!-- <form method="GET" onsubmit="return contentsListForm(this)"> -->
              <!-- <form> -->
              <input
                id="search_type"
                v-model="searchType"
                type="hidden"
                value=""
              />
              <input
                id="search_txt"
                v-model="searchTitle"
                type="text"
                class="input"
                value=""
                placeholder="콘텐츠 명을 입력하세요."
                @keyup.enter="searchContent(searchTitle)"
              />
              <button
                type="button"
                class="submit"
                @click="searchContent(searchTitle)"
              >
                <img src="/assets/images/icon/search_icon.png" alt="" />
              </button>
              <!-- <input type="button" class="submit" @click="searchContent()"> -->
              <!-- </form> -->
            </div>
          </div>
        </div>
      </div>

      <!-- {{ contentList }} -->
      <div class="board_contents none_mt">
        <div class="container">
          <!-- <div v-if="contentList" class="bbs_table_2"> -->
          <div v-if="reversedContentList.length" class="bbs_table_2">
            <!-- <contentlist
              v-for="(item, index) in contentList.content"
              :key="index"
              :class="'list_box'"
            > -->
            <contentlist
              v-for="(item, index) in reversedContentList"
              :key="index"
              :class="'list_box'"
            >
              <router-link :to="'/contents/' + item.idx">
                <div class="img_group">
                  <img :src="item.thumbnail" />

                  <div v-if="item.is_option" class="is_order">
                    <img src="/assets/images/icon/icon_bag.png" />
                    <p>구매가능</p>
                  </div>
                </div>
                <div class="text_group">
                  <div class="text_title" v-html="item.title"></div>
                  <div class="text_info ellipsis_1" v-html="item.summary"></div>

                  <!-- <div class="text_title">{{ item.title }}</div> -->
                  <!-- <div class="text_info ellipsis_1">{{ item.summary }}</div> -->
                  <div class="tag">
                    <div
                      v-for="(keyword, kIndex) in formatTag(item.keyword)"
                      :key="kIndex"
                      v-html="keyword"
                    ></div>

                    <!-- <div v-for="(tag, index) in item.keyword" :key="index">
                      {{tag.replace('#', '')}}
                    </div> -->
                  </div>
                </div>
              </router-link>
            </contentlist>
          </div>

          <!-- <div v-if="!contentList" class="bbs_table_2_nodata"> -->
          <div v-if="!reversedContentList.length" class="bbs_table_2_nodata">
            검색 결과가 없습니다
          </div>
        </div>

        <!-- <div class="bbs_paging">
          <div class="container">
            <ul>
              {% if result %}
                <li><a><img src="/assets/images/icon/page-arrow-left.png" alt="" /></a></li>
                {% for page in range(1, result.page_info.total_pages + 1)%}
                {% if page == result.page_info.current_page %}
                <li><a class="num on" href="/contents?page={{ page }}">{{ page }}</a></li>
                {% else %}
                <li><a class="num" href="/contents?page={{ page }}">{{ page }}</a></li>
                {% endif %}
                {% endfor %}
                <li><a><img src="/assets/images/icon/page-arrow-right.png" alt="" /></a></li>
              {% endif %}
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <div>
    <ScrollToTop />
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue'
// import router from '../router/router.js'
import { useRoute, useRouter } from 'vue-router'
import { loadContent } from '../api/boards'
import ScrollToTop from '../components/ScrollToTop.vue'

export default {
  name: 'ContentViews',
  components: {
    ScrollToTop,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const page = ref(0)
    const category = ref([])
    const contentList = ref([])
    const searchType = ref('')
    const searchTitle = ref('')

    // 토글로 on추가하는 기능 만들어서 search_group쪽 해결해야함....

    // URL 파라미터에서 값을 추출하는 함수
    const getParameterByName = (name) => {
      const params = new URLSearchParams(route.query)
      return params.get(name) || ''
    }

    // eslint-disable-next-line no-shadow
    const getData = async (page, searchType, searchTitle) => {
      const response = await loadContent(page, searchType, searchTitle)
      // console.log(response)
      // eslint-disable-next-line prefer-destructuring
      category.value = response[0]
      // eslint-disable-next-line prefer-destructuring
      contentList.value = response[1]
      // console.log(contentList.value)
    }

    const searchContent = (searchItem) => {
      if (searchTitle.value === searchItem) {
        router.push({
          path: '/contents',
          name: 'ContentViews',
          query: {
            // search_type: searchType.value,
            search_txt: searchTitle.value,
          },
        })
        // getData(0, null, searchTitle.value);
        getData(0, null, searchItem)
      }
    }

    const changeCategory = (type) => {
      searchType.value = type
      router.push({
        path: '/contents',
        name: 'ContentViews',
        query: {
          search_type: type,
        },
      })
      getData(0, type, null)
    }

    // URL 파라미터가 변경될 때 데이터를 로드
    watch(
      () => route.query,
      () => {
        // // console.log("watch 진입");
        searchType.value = getParameterByName('search_type')
        searchTitle.value = getParameterByName('search_txt')
        getData(0, searchType.value || null, searchTitle.value || null)
      },
      { immediate: true }
    )

    const decodeHTMLEntities = (text) => {
      const element = document.createElement('div')
      if (text) {
        element.innerHTML = text
      }
      return element.textContent || element.innerText || ''
    }
    // 역순으로 정렬된 콘텐츠 리스트를 반환하는 computed 속성
    // eslint-disable-next-line arrow-body-style
    const reversedContentList = computed(() => {
      // contentList와 contentList.content가 모두 존재하고 배열일 때만 reverse 실행
      return contentList.value && Array.isArray(contentList.value.content)
        ? [...contentList.value.content].reverse()
        : [] // 값이 없을 때 빈 배열 반환
    })

    const formatTag = (tags) =>
      tags.map((tag) => decodeHTMLEntities(tag.replace('#', '')))
    onMounted(() => {
      searchType.value = getParameterByName('search_type')
      searchTitle.value = getParameterByName('search_txt')
      getData(0, searchType.value || null, searchTitle.value || null)
    })

    return {
      page,
      searchType,
      searchTitle,
      category,
      contentList,
      getData,
      searchContent,
      changeCategory,
      reversedContentList,
      formatTag,
    }
  },
}
</script>
